import { commonFilterOperators, updatePlaceholders } from "../../components/Filter/FilterData/quadrantFilter";

function dateMeasureFilterField(name, id) {
  return {
    name,
    id,
    datatype: "int",
    type: "default",
    placeholder: "Enter value",
    dynamicOptions: false,
    autoComplete: true,
    source: "Adyogi",
    apiKey: `${id}_key`,
    grouping: name,
  };
}

export const PERFORMANCE_DATE_MEASURE_FILTER_FIELDS = [
  dateMeasureFilterField("Total CVR", "total_cvr"),
  dateMeasureFilterField("Total Units", "order_units"),
  dateMeasureFilterField("Total Revenue (GMV)", "gmv"),
  dateMeasureFilterField("Total ROAS", "total_roas"),
  dateMeasureFilterField("Revenue Per Impression (RPI)", "rpi"),
];

const DATE_MEASURE_FILTER_IDS = new Set(
  PERFORMANCE_DATE_MEASURE_FILTER_FIELDS.map((field) => field.id)
);
const DATE_MEASURE_FILTER_CATEGORIES = new Set(
  PERFORMANCE_DATE_MEASURE_FILTER_FIELDS.flatMap((field) => [field.id, field.name])
);

function stripDateMeasureRule(node) {
  if (!node || typeof node !== "object" || Array.isArray(node)) return node;
  if (node.type === "RULE_ITEM") {
    return DATE_MEASURE_FILTER_IDS.has(node.member) ? null : node;
  }

  let changed = false;
  const next = { ...node };
  ["and", "or"].forEach((key) => {
    if (!Array.isArray(node[key])) return;
    const filtered = node[key].map(stripDateMeasureRule).filter(Boolean);
    if (filtered.length !== node[key].length || filtered.some((item, index) => item !== node[key][index])) {
      changed = true;
    }
    next[key] = filtered;
  });

  const items = next.and || next.or;
  if (Array.isArray(items) && items.length === 0) return null;
  return changed ? next : node;
}

export function getPerformanceMeasureFilters(userPlatform, includeDateMeasures) {
  const config = FiltersMeasuresDataPerformance[userPlatform];
  if (!config) return config;
  const fields = (config.fields || []).filter((field) => !DATE_MEASURE_FILTER_IDS.has(field.id));
  return {
    ...config,
    fields: includeDateMeasures
      ? [...fields, ...PERFORMANCE_DATE_MEASURE_FILTER_FIELDS]
      : fields,
  };
}

function stripDateMeasureSection(section) {
  if (!section) return { section, changed: false };

  const groups = section.data;
  const nextGroups = Array.isArray(groups)
    ? groups
        .map((group) => ({
          ...group,
          data: (group.data || []).filter(
            (condition) => !DATE_MEASURE_FILTER_CATEGORIES.has(condition?.category)
          ),
        }))
        .filter((group) => group.data.length > 0)
    : groups;
  const groupsChanged =
    Array.isArray(groups) &&
    JSON.stringify(nextGroups) !== JSON.stringify(groups);

  const customOutput = section.custom_output;
  const nextCustomOutput = stripDateMeasureRule(customOutput);
  if (!groupsChanged && nextCustomOutput === customOutput) {
    return { section, changed: false };
  }

  return {
    changed: true,
    section: {
      ...section,
      data: nextGroups,
      custom_output: nextCustomOutput ?? [],
    },
  };
}

export function stripDateMeasuresFromModuleFilters(filters) {
  if (!filters) return filters;

  let changed = false;
  const next = { ...filters };
  ["metrics", "topX"].forEach((key) => {
    const stripped = stripDateMeasureSection(filters[key]);
    if (stripped.changed) {
      changed = true;
      next[key] = stripped.section;
    }
  });

  return changed ? next : filters;
}

export const FiltersMeasuresDataPerformance = {
    amazon: {
      operators: commonFilterOperators,
      fields: [
        {
          name: "Spends",
          id: "spends",
          datatype: "int",
          type: "default",
          placeholder: "Enter value",
          dynamicOptions: false,
          autoComplete: true,
          source: "Adyogi",
          apiKey: "spends_key",
          grouping: "Spends",
        },
        {
          name: "Revenue",
          id: "revenue",
          datatype: "int",
          type: "default",
          placeholder: "Enter value",
          dynamicOptions: false,
          autoComplete: true,
          source: "Adyogi",
          apiKey: "revenue_key",
          grouping: "Revenue",
        },
        {
          name: "Orders",
          id: "orders",
          datatype: "int",
          type: "default",
          placeholder: "Enter value",
          dynamicOptions: false,
          autoComplete: true,
          source: "Adyogi",
          apiKey: "orders_key",
          grouping: "Orders",
        },
        {
          name: "ROAS",
          id: "roas",
          datatype: "int",
          type: "default",
          placeholder: "Enter value",
          dynamicOptions: false,
          autoComplete: true,
          source: "Adyogi",
          apiKey: "roas_key",
          grouping: "ROAS",
        },
        {
          name: "CTR",
          id: "ctr",
          datatype: "int",
          type: "default",
          placeholder: "Enter value",
          dynamicOptions: false,
          autoComplete: true,
          source: "Adyogi",
          apiKey: "ctr_key",
          grouping: "CTR",
        },
        {
          name: "CPC",
          id: "cpc",
          datatype: "int",
          type: "default",
          placeholder: "Enter value",
          dynamicOptions: false,
          autoComplete: true,
          source: "Adyogi",
          apiKey: "cpc_key",
          grouping: "CPC",
        },
        {
          name: "Bid Adjustment Value",
          id: "bid_adjustment_value",
          datatype: "int",
          type: "default",
          placeholder: "Enter value",
          dynamicOptions: false,
          autoComplete: true,
          source: "Adyogi",
          apiKey: "bid_adjustment_value_key",
          grouping: "Bid Adjustment Value",
        },
        {
          name: "DBR",
          id: "campaign_burn_rate",
          datatype: "int",
          type: "default",
          placeholder: "Enter value",
          dynamicOptions: false,
          autoComplete: true,
          source: "Adyogi",
          apiKey: "campaign_burn_rate_key",
          grouping: "DBR",
        },
        {
          name: "ACOS",
          id: "acos",
          datatype: "int",
          type: "default",
          placeholder: "Enter value",
          dynamicOptions: false,
          autoComplete: true,
          source: "Adyogi",
          apiKey: "acos_key",
          grouping: "ACOS",
        },
      ],
    },
    myntra: {
      operators: commonFilterOperators,
      fields: [
    {
      name: "Spends",
      id: "spends",
      datatype: "int",
      type: "default",
      placeholder: "Enter value",
      dynamicOptions: false,
      autoComplete: true,
      source: "Adyogi",
      apiKey: "spends_key",
      grouping: "Spends",
    },
    {
      name: "Clicks",
      id: "clicks",
      datatype: "int",
      type: "default",
      placeholder: "Enter value",
      dynamicOptions: false,
      autoComplete: true,
      source: "Adyogi",
      apiKey: "clicks_key",
      grouping: "Clicks",
    },
    {
      name: "Impressions",
      id: "impressions",
      datatype: "int",
      type: "default",
      placeholder: "Enter value",
      dynamicOptions: false,
      autoComplete: true,
      source: "Adyogi",
      apiKey: "impressions_key",
      grouping: "Impressions",
    },
    {
      name: "CPC",
      id: "cpc",
      datatype: "int",
      type: "default",
      placeholder: "Enter value",
      dynamicOptions: false,
      autoComplete: true,
      source: "Adyogi",
      apiKey: "cpc_key",
      grouping: "CPC",
    },
    {
      name: "CTR",
      id: "ctr",
      datatype: "int",
      type: "default",
      placeholder: "Enter value",
      dynamicOptions: false,
      autoComplete: true,
      source: "Adyogi",
      apiKey: "ctr_key",
      grouping: "CTR",
    },
    {
      name: "Ads CVR",
      id: "cvr",
      datatype: "int",
      type: "default",
      placeholder: "Enter value",
      dynamicOptions: false,
      autoComplete: true,
      source: "Adyogi",
      apiKey: "cvr_key",
      grouping: "CVR",
    },
    {
      name: "Units (Direct)",
      id: "units_sold_direct",
      datatype: "int",
      type: "default",
      placeholder: "Enter value",
      dynamicOptions: false,
      autoComplete: true,
      source: "Adyogi",
      apiKey: "units_sold_direct_key",
      grouping: "Units",
    },
    {
      name: "Units (Indirect)",
      id: "units_sold_indirect",
      datatype: "int",
      type: "default",
      placeholder: "Enter value",
      dynamicOptions: false,
      autoComplete: true,
      source: "Adyogi",
      apiKey: "units_sold_indirect_key",
      grouping: "Units",
    },
    {
      name: "Ads Units",
      id: "orders",
      datatype: "int",
      type: "default",
      placeholder: "Enter value",
      dynamicOptions: false,
      autoComplete: true,
      source: "Adyogi",
      apiKey: "orders_key",
      grouping: "Units",
    },
    {
      name: "Revenue (Direct)",
      id: "revenue_direct",
      datatype: "int",
      type: "default",
      placeholder: "Enter value",
      dynamicOptions: false,
      autoComplete: true,
      source: "Adyogi",
      apiKey: "revenue_direct_key",
      grouping: "Revenue",
    },
    {
      name: "Revenue (Indirect)",
      id: "revenue_indirect",
      datatype: "int",
      type: "default",
      placeholder: "Enter value",
      dynamicOptions: false,
      autoComplete: true,
      source: "Adyogi",
      apiKey: "revenue_indirect_key",
      grouping: "Revenue",
    },
    {
      name: "Ads Revenue",
      id: "revenue",
      datatype: "int",
      type: "default",
      placeholder: "Enter value",
      dynamicOptions: false,
      autoComplete: true,
      source: "Adyogi",
      apiKey: "revenue_key",
      grouping: "Revenue",
    },
    {
      name: "Revenue (Direct) Percentage",
      id: "direct_revenue_percentage",
      datatype: "int",
      type: "default",
      placeholder: "Enter value",
      dynamicOptions: false,
      autoComplete: true,
      source: "Adyogi",
      apiKey: "direct_revenue_percentage_key",
      grouping: "Revenue",
    },
    {
      name: "Revenue (Indirect) Percentage",
      id: "indirect_revenue_percentage",
      datatype: "int",
      type: "default",
      placeholder: "Enter value",
      dynamicOptions: false,
      autoComplete: true,
      source: "Adyogi",
      apiKey: "indirect_revenue_percentage_key",
      grouping: "Revenue",
    },
    {
      name: "ROAS Direct",
      id: "direct_roas",
      datatype: "int",
      type: "default",
      placeholder: "Enter value",
      dynamicOptions: false,
      autoComplete: true,
      source: "Adyogi",
      apiKey: "direct_roas_key",
      grouping: "ROAS",
    },
    {
      name: "Ads ROAS",
      id: "roas",
      datatype: "int",
      type: "default",
      placeholder: "Enter value",
      dynamicOptions: false,
      autoComplete: true,
      source: "Adyogi",
      apiKey: "roas_key",
      grouping: "ROAS",
    },
    {
      name: "CPM",
      id: "cpm",
      datatype: "int",
      type: "default",
      placeholder: "Enter value",
      dynamicOptions: false,
      autoComplete: true,
      source: "Adyogi",
      apiKey: "cpm_key",
      grouping: "CPM",
    },
    {
      name: "Average Order Value",
      id: "aov",
      datatype: "int",
      type: "default",
      placeholder: "Enter value",
      dynamicOptions: false,
      autoComplete: true,
      source: "Adyogi",
      apiKey: "aov_key",
      grouping: "Average Order Value",
    },
    {
      name: "Ad Sales Per Impression",
      id: "ad_sales_per_impression",
      datatype: "int",
      type: "default",
      placeholder: "Enter value",
      dynamicOptions: false,
      autoComplete: true,
      source: "Adyogi",
      apiKey: "ad_sales_per_impression_key",
      grouping: "Ad Sales Per Impression",
    },
    {
      name: "ACOS",
      id: "acos",
      datatype: "int",
      type: "default",
      placeholder: "Enter value",
      dynamicOptions: false,
      autoComplete: true,
      source: "Adyogi",
      apiKey: "acos_key",
      grouping: "ACOS",
    },
    // {
    //   name: "Clicks DRR",
    //   id: "clicks_drr",
    //   datatype: "int",
    //   type: "default",
    //   placeholder: "Enter value",
    //   dynamicOptions: false,
    //   autoComplete: true,
    //   source: "Adyogi",
    //   apiKey: "clicks_drr_key",
    //   grouping: "Clicks",
    // },
    // {
    //   name: "Spends DRR",
    //   id: "spends_drr",
    //   datatype: "int",
    //   type: "default",
    //   placeholder: "Enter value",
    //   dynamicOptions: false,
    //   autoComplete: true,
    //   source: "Adyogi",
    //   apiKey: "spends_drr_key",
    //   grouping: "Spends",
    // },
    // {
    //   name: "CTR DRR",
    //   id: "ctr_drr",
    //   datatype: "int",
    //   type: "default",
    //   placeholder: "Enter value",
    //   dynamicOptions: false,
    //   autoComplete: true,
    //   source: "Adyogi",
    //   apiKey: "ctr_drr_key",
    //   grouping: "CTR",
    // },
    // {
    //   name: "CVR DRR",
    //   id: "cvr_drr",
    //   datatype: "int",
    //   type: "default",
    //   placeholder: "Enter value",
    //   dynamicOptions: false,
    //   autoComplete: true,
    //   source: "Adyogi",
    //   apiKey: "cvr_drr_key",
    //   grouping: "CVR",
    // },
    // {
    //   name: "Units DRR",
    //   id: "units_sold_drr",
    //   datatype: "int",
    //   type: "default",
    //   placeholder: "Enter value",
    //   dynamicOptions: false,
    //   autoComplete: true,
    //   source: "Adyogi",
    //   apiKey: "units_sold_drr_key",
    //   grouping: "Units",
    // },
    // {
    //   name: "Units (Direct) DRR",
    //   id: "units_sold_direct_drr",
    //   datatype: "int",
    //   type: "default",
    //   placeholder: "Enter value",
    //   dynamicOptions: false,
    //   autoComplete: true,
    //   source: "Adyogi",
    //   apiKey: "units_sold_direct_drr_key",
    //   grouping: "Units",
    // },
    // {
    //   name: "Units (Indirect) DRR",
    //   id: "units_sold_indirect_drr",
    //   datatype: "int",
    //   type: "default",
    //   placeholder: "Enter value",
    //   dynamicOptions: false,
    //   autoComplete: true,
    //   source: "Adyogi",
    //   apiKey: "units_sold_indirect_drr_key",
    //   grouping: "Units",
    // },
    // {
    //   name: "Revenue (Direct) DRR",
    //   id: "revenue_direct_drr",
    //   datatype: "int",
    //   type: "default",
    //   placeholder: "Enter value",
    //   dynamicOptions: false,
    //   autoComplete: true,
    //   source: "Adyogi",
    //   apiKey: "revenue_direct_drr_key",
    //   grouping: "Revenue",
    // },
    // {
    //   name: "Revenue (Indirect) DRR",
    //   id: "revenue_indirect_drr",
    //   datatype: "int",
    //   type: "default",
    //   placeholder: "Enter value",
    //   dynamicOptions: false,
    //   autoComplete: true,
    //   source: "Adyogi",
    //   apiKey: "revenue_indirect_drr_key",
    //   grouping: "Revenue",
    // },
    // {
    //   name: "ROAS DRR",
    //   id: "roas_drr",
    //   datatype: "int",
    //   type: "default",
    //   placeholder: "Enter value",
    //   dynamicOptions: false,
    //   autoComplete: true,
    //   source: "Adyogi",
    //   apiKey: "roas_drr_key",
    //   grouping: "ROAS",
    // },
    // {
    //   name: "CPC DRR",
    //   id: "cpc_drr",
    //   datatype: "int",
    //   type: "default",
    //   placeholder: "Enter value",
    //   dynamicOptions: false,
    //   autoComplete: true,
    //   source: "Adyogi",
    //   apiKey: "cpc_drr_key",
    //   grouping: "CPC",
    // },
    // {
    //   name: "Revenue DRR",
    //   id: "revenue_drr",
    //   datatype: "int",
    //   type: "default",
    //   placeholder: "Enter value",
    //   dynamicOptions: false,
    //   autoComplete: true,
    //   source: "Adyogi",
    //   apiKey: "revenue_drr_key",
    //   grouping: "Revenue",
    // },
  ]
    },
    flipkart: {
      operators: commonFilterOperators,
      fields: [
    {
      name: "Spends",
      id: "spends",
      datatype: "int",
      type: "default",
      placeholder: "Enter value",
      dynamicOptions: false,
      autoComplete: true,
      source: "Adyogi",
      apiKey: "spends_key",
      grouping: "Spends",
    },
    {
      name: "Clicks",
      id: "clicks",
      datatype: "int",
      type: "default",
      placeholder: "Enter value",
      dynamicOptions: false,
      autoComplete: true,
      source: "Adyogi",
      apiKey: "clicks_key",
      grouping: "Clicks",
    },
    {
      name: "Impressions",
      id: "impressions",
      datatype: "int",
      type: "default",
      placeholder: "Enter value",
      dynamicOptions: false,
      autoComplete: true,
      source: "Adyogi",
      apiKey: "impressions_key",
      grouping: "Impressions",
    },
    {
      name: "CPC",
      id: "cpc",
      datatype: "int",
      type: "default",
      placeholder: "Enter value",
      dynamicOptions: false,
      autoComplete: true,
      source: "Adyogi",
      apiKey: "cpc_key",
      grouping: "CPC",
    },
    {
      name: "CTR",
      id: "ctr",
      datatype: "int",
      type: "default",
      placeholder: "Enter value",
      dynamicOptions: false,
      autoComplete: true,
      source: "Adyogi",
      apiKey: "ctr_key",
      grouping: "CTR",
    },
    {
      name: "Ads CVR",
      id: "cvr",
      datatype: "int",
      type: "default",
      placeholder: "Enter value",
      dynamicOptions: false,
      autoComplete: true,
      source: "Adyogi",
      apiKey: "cvr_key",
      grouping: "CVR",
    },
    {
      name: "Units (Direct)",
      id: "units_sold_direct",
      datatype: "int",
      type: "default",
      placeholder: "Enter value",
      dynamicOptions: false,
      autoComplete: true,
      source: "Adyogi",
      apiKey: "units_sold_direct_key",
      grouping: "Units",
    },
    {
      name: "Units (Indirect)",
      id: "units_sold_indirect",
      datatype: "int",
      type: "default",
      placeholder: "Enter value",
      dynamicOptions: false,
      autoComplete: true,
      source: "Adyogi",
      apiKey: "units_sold_indirect_key",
      grouping: "Units",
    },
    {
      name: "Ads Units",
      id: "orders",
      datatype: "int",
      type: "default",
      placeholder: "Enter value",
      dynamicOptions: false,
      autoComplete: true,
      source: "Adyogi",
      apiKey: "orders_key",
      grouping: "Units",
    },
    {
      name: "Revenue (Direct)",
      id: "revenue_direct",
      datatype: "int",
      type: "default",
      placeholder: "Enter value",
      dynamicOptions: false,
      autoComplete: true,
      source: "Adyogi",
      apiKey: "revenue_direct_key",
      grouping: "Revenue",
    },
    {
      name: "Revenue (Indirect)",
      id: "revenue_indirect",
      datatype: "int",
      type: "default",
      placeholder: "Enter value",
      dynamicOptions: false,
      autoComplete: true,
      source: "Adyogi",
      apiKey: "revenue_indirect_key",
      grouping: "Revenue",
    },
    {
      name: "Ads Revenue",
      id: "revenue",
      datatype: "int",
      type: "default",
      placeholder: "Enter value",
      dynamicOptions: false,
      autoComplete: true,
      source: "Adyogi",
      apiKey: "revenue_key",
      grouping: "Revenue",
    },
    {
      name: "Revenue (Direct) Percentage",
      id: "direct_revenue_percentage",
      datatype: "int",
      type: "default",
      placeholder: "Enter value",
      dynamicOptions: false,
      autoComplete: true,
      source: "Adyogi",
      apiKey: "direct_revenue_percentage_key",
      grouping: "Revenue",
    },
    {
      name: "Revenue (Indirect) Percentage",
      id: "indirect_revenue_percentage",
      datatype: "int",
      type: "default",
      placeholder: "Enter value",
      dynamicOptions: false,
      autoComplete: true,
      source: "Adyogi",
      apiKey: "indirect_revenue_percentage_key",
      grouping: "Revenue",
    },
    {
      name: "ROAS Direct",
      id: "direct_roas",
      datatype: "int",
      type: "default",
      placeholder: "Enter value",
      dynamicOptions: false,
      autoComplete: true,
      source: "Adyogi",
      apiKey: "direct_roas_key",
      grouping: "ROAS",
    },
    {
      name: "Ads ROAS",
      id: "roas",
      datatype: "int",
      type: "default",
      placeholder: "Enter value",
      dynamicOptions: false,
      autoComplete: true,
      source: "Adyogi",
      apiKey: "roas_key",
      grouping: "ROAS",
    },
    {
      name: "CPM",
      id: "cpm",
      datatype: "int",
      type: "default",
      placeholder: "Enter value",
      dynamicOptions: false,
      autoComplete: true,
      source: "Adyogi",
      apiKey: "cpm_key",
      grouping: "CPM",
    },
    {
      name: "Average Order Value",
      id: "aov",
      datatype: "int",
      type: "default",
      placeholder: "Enter value",
      dynamicOptions: false,
      autoComplete: true,
      source: "Adyogi",
      apiKey: "aov_key",
      grouping: "Average Order Value",
    },
    {
      name: "Ad Sales Per Impression",
      id: "ad_sales_per_impression",
      datatype: "int",
      type: "default",
      placeholder: "Enter value",
      dynamicOptions: false,
      autoComplete: true,
      source: "Adyogi",
      apiKey: "ad_sales_per_impression_key",
      grouping: "Ad Sales Per Impression",
    },
    {
      name: "ACOS",
      id: "acos",
      datatype: "int",
      type: "default",
      placeholder: "Enter value",
      dynamicOptions: false,
      autoComplete: true,
      source: "Adyogi",
      apiKey: "acos_key",
      grouping: "ACOS",
    },
    // {
    //   name: "Clicks DRR",
    //   id: "clicks_drr",
    //   datatype: "int",
    //   type: "default",
    //   placeholder: "Enter value",
    //   dynamicOptions: false,
    //   autoComplete: true,
    //   source: "Adyogi",
    //   apiKey: "clicks_drr_key",
    //   grouping: "Clicks",
    // },
    // {
    //   name: "Spends DRR",
    //   id: "spends_drr",
    //   datatype: "int",
    //   type: "default",
    //   placeholder: "Enter value",
    //   dynamicOptions: false,
    //   autoComplete: true,
    //   source: "Adyogi",
    //   apiKey: "spends_drr_key",
    //   grouping: "Spends",
    // },
    // {
    //   name: "CTR DRR",
    //   id: "ctr_drr",
    //   datatype: "int",
    //   type: "default",
    //   placeholder: "Enter value",
    //   dynamicOptions: false,
    //   autoComplete: true,
    //   source: "Adyogi",
    //   apiKey: "ctr_drr_key",
    //   grouping: "CTR",
    // },
    // {
    //   name: "CVR DRR",
    //   id: "cvr_drr",
    //   datatype: "int",
    //   type: "default",
    //   placeholder: "Enter value",
    //   dynamicOptions: false,
    //   autoComplete: true,
    //   source: "Adyogi",
    //   apiKey: "cvr_drr_key",
    //   grouping: "CVR",
    // },
    // {
    //   name: "Units DRR",
    //   id: "units_sold_drr",
    //   datatype: "int",
    //   type: "default",
    //   placeholder: "Enter value",
    //   dynamicOptions: false,
    //   autoComplete: true,
    //   source: "Adyogi",
    //   apiKey: "units_sold_drr_key",
    //   grouping: "Units",
    // },
    // {
    //   name: "Units (Direct) DRR",
    //   id: "units_sold_direct_drr",
    //   datatype: "int",
    //   type: "default",
    //   placeholder: "Enter value",
    //   dynamicOptions: false,
    //   autoComplete: true,
    //   source: "Adyogi",
    //   apiKey: "units_sold_direct_drr_key",
    //   grouping: "Units",
    // },
    // {
    //   name: "Units (Indirect) DRR",
    //   id: "units_sold_indirect_drr",
    //   datatype: "int",
    //   type: "default",
    //   placeholder: "Enter value",
    //   dynamicOptions: false,
    //   autoComplete: true,
    //   source: "Adyogi",
    //   apiKey: "units_sold_indirect_drr_key",
    //   grouping: "Units",
    // },
    // {
    //   name: "Revenue (Direct) DRR",
    //   id: "revenue_direct_drr",
    //   datatype: "int",
    //   type: "default",
    //   placeholder: "Enter value",
    //   dynamicOptions: false,
    //   autoComplete: true,
    //   source: "Adyogi",
    //   apiKey: "revenue_direct_drr_key",
    //   grouping: "Revenue",
    // },
    // {
    //   name: "Revenue (Indirect) DRR",
    //   id: "revenue_indirect_drr",
    //   datatype: "int",
    //   type: "default",
    //   placeholder: "Enter value",
    //   dynamicOptions: false,
    //   autoComplete: true,
    //   source: "Adyogi",
    //   apiKey: "revenue_indirect_drr_key",
    //   grouping: "Revenue",
    // },
    // {
    //   name: "ROAS DRR",
    //   id: "roas_drr",
    //   datatype: "int",
    //   type: "default",
    //   placeholder: "Enter value",
    //   dynamicOptions: false,
    //   autoComplete: true,
    //   source: "Adyogi",
    //   apiKey: "roas_drr_key",
    //   grouping: "ROAS",
    // },
    // {
    //   name: "CPC DRR",
    //   id: "cpc_drr",
    //   datatype: "int",
    //   type: "default",
    //   placeholder: "Enter value",
    //   dynamicOptions: false,
    //   autoComplete: true,
    //   source: "Adyogi",
    //   apiKey: "cpc_drr_key",
    //   grouping: "CPC",
    // },
    // {
    //   name: "Revenue DRR",
    //   id: "revenue_drr",
    //   datatype: "int",
    //   type: "default",
    //   placeholder: "Enter value",
    //   dynamicOptions: false,
    //   autoComplete: true,
    //   source: "Adyogi",
    //   apiKey: "revenue_drr_key",
    //   grouping: "Revenue",
    // },
  ]
    },
  };
  
  export const FiltersDimensionDataPerformance = {
    amazon: {
      operators: commonFilterOperators,
      fields: [
        {
          name: "Campaign Name",
          id: "campaign_name",
          datatype: "string",
          type: "default",
          placeholder: "Enter value",
          dynamicOptions: true,
          optionsKey: "campaign_names_api_key",
          source: "BackendAll",
          optionsType: "Static",
          dataFromApi: true,
          apiKey: "campaign_names_api_key",
          backendSearch: true,
          grouping: "Campaign Name",
        },
        {
          name: "Portfolio Name",
          id: "portfolio_name",
          datatype: "string",
          type: "default",
          placeholder: "Enter value",
          dynamicOptions: true,
          optionsKey: "portfolio_names_api_key",
          source: "BackendAll",
          optionsType: "Static",
          dataFromApi: true,
          apiKey: "portfolio_names_api_key",
          backendSearch: true,
          grouping: "Portfolio Name",
        },
        {
          name: "Campaign Type",
          id: "campaign_type",
          datatype: "string",
          type: "default",
          placeholder: "Enter value",
          dynamicOptions: false,
          autoComplete: true,
          source: "Adyogi",
          optionsType: "Static",
          optionsKey: "SP,SB(V),SB",
          grouping: "Campaign Type",
        },
        {
          name: "Placement",
          id: "placement_name",
          datatype: "string",
          type: "default",
          placeholder: "Enter value",
          dynamicOptions: false,
          autoComplete: true,
          source: "Adyogi",
          optionsType: "Static",
          optionsKey: "Top of Search,Detail Page on-Amazon,Other Placements",
          grouping: "Placement",
        },
        {
          name: "Campaign Format",
          id: "campaign_format",
          datatype: "string",
          type: "default",
          placeholder: "Enter value",
          dynamicOptions: false,
          autoComplete: true,
          source: "Adyogi",
          optionsType: "Static",
          optionsKey: "Prospect,Retarget",
          grouping: "Campaign Format",
        },
        {
          name: "Campaign Status",
          id: "campaign_status",
          datatype: "string",
          type: "default",
          placeholder: "Enter value",
          dynamicOptions: false,
          autoComplete: true,
          source: "Adyogi",
          optionsType: "Static",
          optionsKey: "PAUSED,ENABLED,ARCHIVED",
          grouping: "Campaign Status",
        },
        {
          name: "Targeting Type",
          id: "targeting_type",
          datatype: "string",
          type: "default",
          placeholder: "Enter value",
          dynamicOptions: false,
          autoComplete: true,
          source: "Adyogi",
          optionsType: "Static",
          optionsKey:
            "G.Keyword,C.Keyword,NB.Keyword,Audience,Automatic,NB.Product,B.Keyword,B.Audience,B.Product",
          grouping: "Targeting Type",
        },
        {
          name: "Bid Strategy",
          id: "campaign_bid_strategy",
          datatype: "string",
          type: "default",
          placeholder: "Enter value",
          dynamicOptions: false,
          autoComplete: true,
          source: "Adyogi",
          optionsType: "Static",
          optionsKey: "Down,Up & Down",
          grouping: "Bid Strategy",
        },
      ],
    },
    myntra: {
      operators: commonFilterOperators,
      fields:[]
    },
    flipkart: {
      operators: commonFilterOperators,
      fields:[]
    },
  };
  
  export const FiltersCampaignDataPerformance = {
    amazon: {
      operators: commonFilterOperators,
      fields: []
    },
    myntra: {
      operators: commonFilterOperators,
      fields: [],
    },
    flipkart: {
      operators: commonFilterOperators,
      fields: [],
    },
  };
  
  
  
  export const useTopXDataPerformanceConfig = () => {
    const userPlatform = JSON.parse(localStorage.getItem("user_platform"));
    
    return {
      operators: {int: [
        { id: "TOP", name: "Top",multiple:false },
        { id: "BOTTOM", name: "Bottom",multiple:false }
      ]},
      fields: updatePlaceholders(FiltersMeasuresDataPerformance[userPlatform].fields)
    }
  }